import React, { useState, useEffect } from 'react';
import { serverTimestamp } from 'firebase/firestore';
import { 
  Form, 
  Input, 
  Button, 
  Typography, 
  Card, 
  Select, 
  Upload, 
  message,
  Skeleton
} from 'antd';
import { 
  UploadOutlined,
  SaveOutlined
} from '@ant-design/icons';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useParams, useNavigate } from 'react-router-dom';

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const BlogEdit = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const docRef = doc(db, "blogPosts", id);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          form.setFieldsValue({
            title: data.title,
            excerpt: data.excerpt,
            content: data.content,
            category: data.category,
            featured: data.featured,
            relatedArticles: data.relatedArticles
          });
          setImageUrl(data.image);
        } else {
          message.error('Blog post not found');
          navigate('/admin');
        }
      } catch (error) {
        console.error("Error fetching document: ", error);
        message.error('Failed to load blog post');
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id, form, navigate]);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      
      const blogData = {
        ...values,
        image: imageUrl,
        updatedAt: serverTimestamp()
      };

      await updateDoc(doc(db, "blogPosts", id), blogData);
      message.success('Blog post updated successfully!');
      navigate(`/article/${id}`);
    } catch (error) {
      console.error("Error updating document: ", error);
      message.error('Failed to update blog post');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Skeleton active />;
  }

  return (
    <div className="blog-edit-container">
      <Card title={<Title level={2}>Edit Blog Post</Title>}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          {/* Same form fields as BlogUpload.js */}
          {/* ... */}
          
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} icon={<SaveOutlined />}>
              Update Blog Post
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default BlogEdit;